import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { useFilters } from '@domain-group/react-hooks'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import useBrandProvider from '@hooks/useBrandProvider'
import useBrandProviders from '@hooks/useBrandProviders'

import DashboardModuleFilters from '@components/DashboardModuleFilters'
import ScopedConditionalContent from '@components/ScopedConditionalContent'

import BrandProviderListItem from './BrandProviderListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'brand_title',
      label: 'Filter by Title or ID',
    },
  ]
}

const BrandProviders = (props: { providerId: number }) => {
  const { providerId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const brandProvidersPayload = useBrandProviders({
    filters: { provider_id: providerId, ...pageFilters },
    performHttpRequests: !!providerId,
    requestOptions: {
      include_brand_provider_brand: true,
    },
    sortKey: 'brand',
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredBrandProviders,
    filteredBrandProvidersCount,
    hasFilteredBrandProviders,
    loading,
  } = brandProvidersPayload

  const {
    callbacks: { addBrandProvider },
  } = useBrandProvider({ provider_id: providerId })

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-brands' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Brands"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <Box flexDirection="column">
        {!loading && !hasFilteredBrandProviders && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Brands present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please assign a Brand below.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredBrandProviders && (
          // @ts-expect-error TS2322
          <DashboardModule.ScrollableSection flexDirection="column">
            {filteredBrandProviders.map(brandProvider => (
              <BrandProviderListItem
                key={brandProvider.id}
                brandProvider={brandProvider}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredBrandProvidersCount}
          loading={loading}
        >
          <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => addBrandProvider()}
              // @ts-expect-error TS2322
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Brand
            </Button>
          </ScopedConditionalContent>
        </DashboardModule.LoadMoreFooter>
      </Box>
    </DashboardModule>
  )
}

export default BrandProviders
